<div>
    <mat-card class="form-card">        
        <mat-card-header class="custom-card-header">
            <mat-card-title class="custom-card-title">
                Save Pickup Location            
            </mat-card-title>
        </mat-card-header>
        
            <mat-card-content>
                @if (isFormReady()) {
                    <div class="form-container">                        
                        <!-- 1. Location Name (Required) -->
                        <mat-form-field appearance="outline">
                            <mat-label>Location Name <span class="text-red-600">*</span></mat-label>
                            <input matInput type="text" #locationNameInput placeholder="Enter Location Name" 
                                [value]="pickupLocationName()" 
                                (input)="pickupLocationName.set(locationNameInput.value)">
                                @if (!pickupLocationName() && submitted()) {
                                    <mat-error>Location Name is required</mat-error>
                                }
                        </mat-form-field>

                        <!-- 2. Same as Customer Address? (Toggle) -->
                        <div class="col-span-1 flex items-center pt-2">
                            <mat-slide-toggle 
                                [checked]="sameAsCustomerAddress()" 
                                (change)="onAddressCheck($event)"
                                color="primary" class="text-gray-700">
                                Same as CustomerAddress?
                            </mat-slide-toggle>
                        </div>                            
                        <!-- 3. Address Line 1 -->
                        <mat-form-field appearance="outline" class="col-span-1 w-full">
                            <mat-label>Address Line 1</mat-label>
                            <input matInput type="text" #addr1Input placeholder="Enter Address Line 1" 
                                [value]="addressLine1()" 
                                (input)="addressLine1.set(addr1Input.value)"
                                [disabled]="sameAsCustomerAddress()">
                        </mat-form-field>

                        <!-- 4. Address Line 2 -->
                        <mat-form-field appearance="outline" class="col-span-1 w-full">
                            <mat-label>Address Line 2</mat-label>
                            <input matInput type="text" #addr2Input placeholder="Enter Address Line 2" 
                                [value]="addressLine2()" 
                                (input)="addressLine2.set(addr2Input.value)"
                                [disabled]="sameAsCustomerAddress()">
                        </mat-form-field>

                        <!-- 5. City -->
                        <mat-form-field appearance="outline" class="col-span-1 w-full">
                            <mat-label>City</mat-label>
                            <input matInput type="text" #cityInput placeholder="Enter City" 
                                [value]="city()" 
                                (input)="city.set(cityInput.value)"
                                [disabled]="sameAsCustomerAddress()">
                        </mat-form-field>

                        <!-- 6. State -->
                        <mat-form-field appearance="outline" class="col-span-1 w-full">
                            <mat-label>State</mat-label>
                            <input matInput type="text" #stateInput placeholder="Enter State" 
                                [value]="state()" 
                                (input)="state.set(stateInput.value)"
                                [disabled]="sameAsCustomerAddress()">
                        </mat-form-field>

                        <!-- 7. Zip Code -->
                        <mat-form-field appearance="outline" class="col-span-1 w-full">
                            <mat-label>Zip Code</mat-label>
                            <input matInput type="text" #zipInput placeholder="Enter Zip Code" 
                                [value]="zipCode()" 
                                (input)="zipCode.set(zipInput.value)"
                                [disabled]="sameAsCustomerAddress()">
                        </mat-form-field>

                        <!-- 8. Municipality -->
                        <mat-form-field appearance="outline" class="col-span-1 w-full">
                            <mat-label>Municipality</mat-label>
                            <input matInput type="text" #muniInput placeholder="Enter Municipality" 
                                [value]="municipality()" 
                                (input)="municipality.set(muniInput.value)"
                                [disabled]="sameAsCustomerAddress()">
                        </mat-form-field>

                        <!-- 9. Market(s) -->
                        <mat-form-field appearance="outline" class="sm:col-span-2 w-full">
                            <mat-label>Market(s)</mat-label>
                            <mat-select 
                                [value]="marketID()" 
                                (valueChange)="marketID.set($event)"
                                placeholder="Select Market(s)">
                                @for (market of marketOptions(); track market.id) {
                                    <mat-option [value]="market.id">{{ market.regionName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>                  
                    </div>
                }
            </mat-card-content>
            <mat-card-footer align="end" class="dialog-footer">
                <button data-testid="btnSave" mat-raised-button color="primary"
                    mat-primary type="button" (click)="savePickupLocation()" [disabled]="!showSaveButton()">
                    Save
                </button>
                <button data-testid="btnClose" mat-raised-button color="primary" mat-primary type="button" (click)="onClose()">
                    Close
                </button>
            </mat-card-footer>
    </mat-card>
</div>